const getTimeBetween = (startDate: Date, endDate: Date): number => {
  const differenceInMinutes =
    new Date(endDate).getTime() - new Date(startDate).getTime();
  return Number(differenceInMinutes / 60 / 1000 / 60);
};

const getDayName = (dayIndex: number) => {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  return days[dayIndex];
};

function getUniqueDaysBetweenDates(
  startDate: Date,
  endDate: Date
): Array<string> {
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const days = new Set();
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);
  const currentDate = new Date(startDate);
  while (currentDate <= endDate) {
    const dayOfWeek = daysOfWeek[currentDate.getDay()];
    days.add(dayOfWeek);
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return Array.from(days as unknown as string[]);
}

const getFormattedTime = (currentDate: Date) => {
  //const currentDate = new Date();

  const hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const amOrPm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12; // Handle midnight (0) as 12 AM
  const formattedMinutes = minutes.toString().padStart(2, "0"); // Ensure two-digit minutes

  return `${formattedHours}:${formattedMinutes} ${amOrPm}`;
};

const getEndTime = (startDate: Date, duration: number) => {
  const minutesToAdd = duration * 60;
  const newStartDate = new Date(startDate);
  const endDateTime = newStartDate.setMinutes(
    startDate.getMinutes() + minutesToAdd
  );

  return new Date(endDateTime);
};

const getDatesBetween = (startDate: Date, endDate: Date): Date[] => {
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);
  const dates: Date[] = [];
  const currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    dates.push(new Date(currentDate)); // Add current date to array
    currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
  }

  return dates;
};

const replaceDatePart = (originalDate: Date, newDatePart: Date): Date => {
  const updatedDate = new Date(newDatePart);

  // Set the time part from the original date
  updatedDate.setHours(originalDate.getHours());
  updatedDate.setMinutes(originalDate.getMinutes());
  updatedDate.setSeconds(originalDate.getSeconds());
  updatedDate.setMilliseconds(originalDate.getMilliseconds());

  return updatedDate;
};

export {
  getDatesBetween,
  getDayName,
  getEndTime,
  getFormattedTime,
  getTimeBetween,
  getUniqueDaysBetweenDates,
  replaceDatePart,
};
